import React from 'react';
import { FormattedDate } from 'react-intl';
import { useSelector } from 'react-redux';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { OfferPrice } from 'components/Offer/Shared/OfferPrice';
import { getShowTotalPrices } from 'modules/sapiSearch/selectors';
import { SearchOffer } from 'modules/sapiSearch/slice';
import { imageProvider } from 'utils/imageProvider';
import { Box } from '@daedalus/atlas/helpers/Box';
import { Image } from '@daedalus/atlas/Image';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { dateStringToMiddayDate } from '@daedalus/core/src/utils/date';
import { GuestAndRoomText } from '@daedalus/shared/src/search/GuestAndRoomsText';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1azqu33",
  propsAsIs: false
});
const HotelInfoContainer = /*#__PURE__*/styled('div')({
  name: "HotelInfoContainer",
  class: "hxvmi1o",
  propsAsIs: false
});
const _exp9 = /*#__PURE__*/() => Text;
const HotelName = /*#__PURE__*/styled(_exp9())({
  name: "HotelName",
  class: "h2keuva",
  propsAsIs: true
});
const _exp10 = /*#__PURE__*/() => Text;
const BodyText = /*#__PURE__*/styled(_exp10())({
  name: "BodyText",
  class: "bhej42",
  propsAsIs: true
});
const ImageContainer = /*#__PURE__*/styled('div')({
  name: "ImageContainer",
  class: "i1106u7d",
  propsAsIs: false
});
const PriceWrapper = /*#__PURE__*/styled('div')({
  name: "PriceWrapper",
  class: "p1de0jil",
  propsAsIs: false
});
const Spacer = /*#__PURE__*/styled('div')({
  name: "Spacer",
  class: "sz8aifq",
  propsAsIs: false
});
interface Props {
  imageUrl: string;
  title: string;
  checkIn?: string;
  checkOut?: string;
  rooms: string;
  placeholderImage: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  fullWidth?: boolean;
  testId?: string;
  isCompactImage?: boolean;
  hotelId?: string;
  offer?: SearchOffer;
}
export const MinimalHotelCard: React.FC<Props> = ({
  imageUrl,
  title,
  checkIn,
  checkOut,
  rooms,
  placeholderImage,
  onClick,
  fullWidth,
  testId,
  isCompactImage = false,
  offer,
  hotelId
}) => {
  const showTotalPrices = useSelector(getShowTotalPrices);
  const shouldShowOffer = offer && hotelId;
  return <Wrapper data-id={testId} className={cx(fullWidth && '__isFullWidth', onClick && '__hasOnClick')} onClick={onClick}>
      <ImageContainer className={cx(isCompactImage && '__isCompactImage')}>
        <Image url={imageUrl} placeHolderImage={placeholderImage} imageProvider={imageProvider} size="main" isResponsive hasSkeletonLoader />
      </ImageContainer>
      <HotelInfoContainer>
        <HotelName variant="labelS" className={cx(fullWidth && '__fullWidth')}>
          {title}
        </HotelName>
        <div>
          {checkIn && checkOut && <Box display="flex" alignItems="center" gap="s200">
              <BodyText variant="bodyS">
                <FormattedDate value={dateStringToMiddayDate(checkIn)} month="short" day="2-digit" />
              </BodyText>
              -
              <BodyText variant="bodyS">
                <FormattedDate value={dateStringToMiddayDate(checkOut)} month="short" day="2-digit" />
              </BodyText>
            </Box>}
          <BodyText variant="bodyS">
            <GuestAndRoomText rooms={rooms} />
          </BodyText>
        </div>
      </HotelInfoContainer>
      {shouldShowOffer && <>
          <Spacer />
          <PriceWrapper>
            <OfferPrice size="lg" offer={offer} hotelId={hotelId} anchorPrice={undefined} />
            <Text variant="bodyS" colorPath="content.neutral.c600" align="end">
              {showTotalPrices ? <FormattedMessageWrapper id="payment.total" defaultMessage="total" /> : <FormattedMessageWrapper id="perNight" defaultMessage="/ night" />}
            </Text>
          </PriceWrapper>
        </>}
    </Wrapper>;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");